<script setup>
import { useI18n } from 'vue-i18n';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  tool: { type: Object, required: true },
  deletable: { type: Boolean, default: true },
});

const emit = defineEmits(['delete', 'edit']);
const { t } = useI18n();
</script>

<template>
  <CardLayout>
    <div class="flex items-start justify-between w-full gap-3">
      <div class="min-w-0">
        <div class="flex items-center gap-2">
          <h3 class="text-base text-n-slate-12">{{ tool.name }}</h3>
          <span v-if="tool.enabled === false" class="text-xs text-n-slate-10">
            {{ t('ARROWS_AI.TOOLS.DISABLED') }}
          </span>
        </div>
        <p class="mt-1 text-sm text-n-slate-11">{{ tool.description }}</p>
        <p v-if="tool.endpoint" class="mt-1 text-xs truncate text-n-slate-10">
          {{ tool.httpMethod || 'GET' }} {{ tool.endpoint }}
        </p>
      </div>
      <div v-if="deletable" class="flex items-center gap-1">
        <Button
          :label="t('ARROWS_AI.TOOLS.EDIT')"
          color="slate"
          variant="ghost"
          size="sm"
          icon="i-lucide-pencil"
          @click="emit('edit', tool)"
        />
        <Button
          :label="t('ARROWS_AI.TOOLS.DELETE')"
          color="ruby"
          variant="ghost"
          size="sm"
          icon="i-lucide-trash"
          @click="emit('delete', tool.id)"
        />
      </div>
    </div>
  </CardLayout>
</template>
